<script setup lang="ts">
// Renders the active confirm request as a Modal (mount once in the app shell).
import { nextTick, watch } from 'vue'

import { useI18n } from '@/shared/i18n'
import { Button } from '@/shared/ui/button'
import { Modal } from '@/shared/ui/modal'
import { useUiStore } from '@/shared/ui/store/uiStore'

const store = useUiStore()
const { t } = useI18n()
let returnFocus: HTMLElement | null = null

watch(
  () => store.confirm?.id ?? null,
  async (id, previousId) => {
    if (id !== null && previousId === null) {
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null
      return
    }
    if (id !== null || previousId === null) return

    await nextTick()
    if (returnFocus?.isConnected) returnFocus.focus()
    returnFocus = null
  },
  { flush: 'sync' },
)
</script>

<template>
  <Modal
    v-if="store.confirm"
    :model-value="true"
    :title="store.confirm.title ?? ''"
    size="sm"
    @update:model-value="store.resolveConfirm(false)"
  >
    <p class="ui-confirm__message m-0 text-fg text-sm leading-normal">
      {{ store.confirm.message }}
    </p>
    <template #footer>
      <Button variant="soft" @click="store.resolveConfirm(false)">
        {{ store.confirm.cancelLabel ?? t('common.cancel') }}
      </Button>
      <Button
        :variant="store.confirm.danger ? 'danger' : 'primary'"
        @click="store.resolveConfirm(true)"
      >
        {{ store.confirm.confirmLabel ?? t('common.confirm') }}
      </Button>
    </template>
  </Modal>
</template>
